"use client";

import React, { useEffect, useState } from "react";
import "./account.css";
import "../upgrade/upgrade.css";

import { fetchAPI } from "../../utils/api";

// imports for payment history table
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Videopop from "./video.jsx";

// imports for payment history table
import { PiHandSwipeLeftLight } from "react-icons/pi";
import { useRouter } from "next/navigation";
import { phoneCodes } from "../../utils/phoneCodes.js";
import { countriesRes, provincesRes, citiesRes } from "../finder/data";

const MenuContent = ({
  content,
  userDetails,
  setUserDetails,
  usageSummary,
  usageStatement,
  paymentHistory,
  passwordChange,
  setPasswordChange,
  updateUserDetails,
  setUpdateUserDetails,
  countries,
  provinces,
  cities,
  bookings,
  handleUpgradeSubmit,
  idType,
  setIdType,
  idNumber,
  setIdNumber,
  getIdInputLabel,
}) => {
  // Define your content components here
  const ContentComponent =
    contentComponents[content] || contentComponents.default;
  return (
    <ContentComponent
      userDetails={userDetails}
      setUserDetails={setUserDetails}
      usageSummary={usageSummary}
      usageStatement={usageStatement}
      paymentHistory={paymentHistory}
      passwordChange={passwordChange}
      setPasswordChange={setPasswordChange}
      updateUserDetails={updateUserDetails}
      setUpdateUserDetails={setUpdateUserDetails}
      countries={countries}
      provinces={provinces}
      cities={cities}
      bookings={bookings}
      handleUpgradeSubmit={handleUpgradeSubmit}
      idType={idType}
      getIdInputLabel={getIdInputLabel}
    />
  );
};

const contentComponents = {
  profile: ({
    userDetails,
    setUserDetails,
    updateUserDetails,
    setUpdateUserDetails,
    countries,
    provinces,
    cities,
  }) => (
    <div>
      <section className="account-details">
        <div className="account-details-card">
          <h2>Edit your profile</h2>
          <div className="update-profile">
            <div>
              <div className="field-cont">
                <label htmlFor="title">Title</label>
                <select
                  id="title"
                  name="title"
                  value={
                    userDetails.Title === ""
                      ? userDetails.Family?.[0].Title
                      : userDetails.Title
                  }
                >
                  <option>Please select</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Dr">Dr</option>
                </select>
              </div>
              <div className="field-cont">
                <label htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  value={
                    userDetails?.FirstName === ""
                      ? userDetails?.Family?.[0]?.FirstName
                      : userDetails?.FirstName
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      FirstName: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="field-cont">
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  value={
                    userDetails?.Surname === ""
                      ? userDetails?.Family?.[0]?.LastName
                      : userDetails?.Surname
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      Surname: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div>
              <div className="field-cont">
                <label htmlFor="DOB">Date of birth</label>
                <input
                  type="date"
                  id="DOB"
                  value={
                    userDetails?.BirthDate
                      ? new Date(userDetails.BirthDate)
                          .toISOString()
                          .split("T")[0]
                      : ""
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      BirthDate: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="field-cont">
                <label htmlFor="emailAddress">Email address</label>
                <input
                  type="email"
                  id="emailAddress"
                  value={
                    userDetails?.HomeEmail?.[0]?.EmailAddress === ""
                      ? userDetails?.Family?.[0]?.Email
                      : userDetails?.HomeEmail?.[0]?.EmailAddress
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      HomeEmail: [{ EmailAddress: e.target.value }],
                    });
                  }}
                />
              </div>
            </div>
            <div>
              <div className="field-cont">
                <label htmlFor="code1">Code</label>
                <select
                  value={phoneCodes[0].code}
                  onChange={(e) => setUserDetails(userDetails)}
                  className="no-spinners"
                >
                  {phoneCodes.map((option) => (
                    <option key={option.code} value={option.code}>
                      {option.code}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field-cont">
                <label htmlFor="cellphoneNumber1">Cellphone Number</label>
                <input
                  type="phone"
                  id="cellphoneNumber1"
                  value={
                    userDetails?.CellPhone?.PhoneNumber === ""
                      ? userDetails?.Family?.[0]?.CellPhone
                      : userDetails?.CellPhone?.PhoneNumber
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      CellPhone: { PhoneNumber: e.target.value },
                    });
                  }}
                />
              </div>
              <div className="field-cont">
                <label htmlFor="code2">Code</label>
                <select
                  value={phoneCodes[0].code}
                  onChange={(e) => setUserDetails(userDetails)}
                  className="no-spinners"
                >
                  {phoneCodes.map((option) => (
                    <option key={option.code} value={option.code}>
                      {option.code}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field-cont">
                <label htmlFor="cellphoneNumber2">
                  ALTERNATIVE CELLPHONE NUMBER
                </label>
                <input
                  type="phone"
                  id="cellphoneNumber2"
                  value={
                    userDetails?.CellPhone2?.PhoneNumber === ""
                      ? userDetails?.Family?.[0]?.Telephone
                      : userDetails?.CellPhone2?.PhoneNumber
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      CellPhone2: { PhoneNumber: e.target.value },
                    });
                  }}
                />
              </div>
            </div>
            <div className="field-cont" style={{ width: "100%" }}>
              <label htmlFor="physicalAddress">Physical Address</label>
              <input
                type="text"
                id="physicalAddress"
                value={userDetails?.PhysicalAddress?.Line1}
                onChange={(e) => {
                  setUserDetails({
                    ...userDetails,
                    PhysicalAddress: {
                      ...userDetails.PhysicalAddress,
                      Line1: e.target.value,
                    },
                  });
                }}
              />
              <input
                type="text"
                id="physicalAddress2"
                value={userDetails?.PhysicalAddress?.Line2}
                onChange={(e) => {
                  setUserDetails({
                    ...userDetails,
                    PhysicalAddress: {
                      ...userDetails.PhysicalAddress,
                      Line2: e.target.value,
                    },
                  });
                }}
              />
            </div>
            <div>
              <div className="field-cont">
                <label htmlFor="country">Country</label>
                <select
                  value={userDetails?.PhysicalAddress?.CountryID}
                  onChange={(e) =>
                    setUserDetails({
                      ...userDetails,
                      PhysicalAddress: {
                        ...userDetails.PhysicalAddress,
                        CountryID: e.target.value,
                        Country:
                          countries.find(
                            (country) => country.Id === e.target.value
                          )?.name || "South Africa",
                      },
                    })
                  }
                >
                  <option value="">Select Country</option>
                  {countries.map((option) => (
                    <option key={option.Id} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field-cont">
                <label htmlFor="province">Province</label>
                <select
                  value={userDetails?.PhysicalAddress?.ProvinceID}
                  onChange={(e) =>
                    setUserDetails({
                      ...userDetails,
                      PhysicalAddress: {
                        ...userDetails.PhysicalAddress,
                        ProvinceID: e.target.value,
                        Province:
                          provinces.find(
                            (province) => province.Id === e.target.value
                          )?.name || "Gauteng",
                      },
                    })
                  }
                >
                  <option value="">Select Province</option>
                  {provinces.map((option) => (
                    <option key={option.Id} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="field-cont">
              <label htmlFor="city">City</label>
              <select
                value={userDetails?.PhysicalAddress?.CityID}
                onChange={(e) =>
                  setUserDetails({
                    ...userDetails,
                    PhysicalAddress: {
                      ...userDetails.PhysicalAddress,
                      CityID: e.target.value,
                      City:
                        cities.find((city) => city.ID === e.target.value)
                          ?.Name || "Johannesburg",
                      PostalCode: cities.find(
                        (city) => city.ID === e.target.value
                      )?.PostalCode,
                    },
                  })
                }
              >
                <option value="">Select City</option>
                {cities.map((option) => (
                  <option key={option.ID} value={option.ID}>
                    {option.Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="field-cont" style={{ width: "100%" }}>
              <input
                className="checkbox-radius"
                type="checkbox"
                id="optIn"
                value={userDetails?.ReceivePromotionalEmails}
                onChange={(e) => {
                  setUserDetails({
                    ...userDetails,
                    ReceivePromotionalEmails:
                      !userDetails?.ReceivePromotionalEmails,
                  });
                }}
                checked={userDetails?.ReceivePromotionalEmails}
              />
              <label htmlFor="optIn">
                Receive Promotional emails from First Loyalty Plus
              </label>
            </div>
            <div className="btn-cont">
              <button
                className="editSave"
                type="button"
                disabled={updateUserDetails}
                onClick={() => setUpdateUserDetails(true)}
              >
                {updateUserDetails ? "Please Wait..." : "Save"}
              </button>
              <button type="cancel">Cancel</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  ),
  bookingsHistory: ({ bookings }) => (
    <div>
      <section className="booking-history">
        <div className="booking-history-card">
          <h2>Your Booking History</h2>

          <div className="booking-history">
            <div className="results">
              {bookings?.map((booking, index) => (
                <React.Fragment key={index}>
                  <div key={index} className="resturant-result">
                    {/* Restaurant result start */}
                    <div className="resturant-result-child-1">
                      <img
                        src={
                          "https://nouf-flp-images.s3.af-south-1.amazonaws.com/34692t16.jpeg"
                        }
                        alt="dummy-booking-img"
                      />
                    </div>

                    <div className="resturant-result-child-2">
                      {/* Restaurant details */}
                      <div className="resturant-details">
                        <div className="resturant-details-1">
                          <h3 style={{ color: "white" }}>
                            {booking.ResortName}
                          </h3>
                          <br />
                          <p style={{ color: "white" }}>
                            {booking.Lines[0].Unit}
                          </p>
                          <div style={{ color: "white" }} className="deatils">
                            <div className="deatils-1">
                              <div className="d1-item1">
                                <h5>ARRIVAL: </h5>
                                {/* {booking.bookingarrival} */}

                                <h5>DEPARTURE: </h5>
                                {/* {booking.bookingdeparture} */}

                                <h5>ADULTS: </h5>

                                <h5>CHILDREN: </h5>
                              </div>
                              <div className="d1-item2">
                                {new Date(booking.StartDate)
                                  .toISOString()
                                  .split("T")[0]
                                  .replace(/-/g, "/")}
                                <br />
                                {new Date(booking.EndDate)
                                  .toISOString()
                                  .split("T")[0]
                                  .replace(/-/g, "/")}
                                <br />
                                {booking.Lines[0].Adults}
                                <br />
                                {/* <h5>CHILDREN</h5> */}
                                {booking.Lines[0].Children}
                              </div>
                            </div>
                            <br />
                            <a className="button-map" href="www.google.com">
                              <button className="map-but">VIEW MY UNITS</button>
                            </a>
                          </div>
                        </div>
                      </div>
                      {/* Restaurant details end */}
                    </div>
                    {/* Restaurant result end */}
                  </div>
                  <hr className="solid" />{" "}
                  {/* This line adds a horizontal line after each restaurant result */}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  ),
  paymentHistory: ({ paymentHistory }) => (
    <div className="payment-history">
      <section className="account-details">
        <div className="payment-history-card">
          <h2>Your Payment History</h2>

          <div className="mobile-swipe-left">
            <h3>
              <PiHandSwipeLeftLight />
            </h3>

            <br />
          </div>

          <div className="payment-history">
            <TableContainer
              component={Paper}
              sx={{ backgroundColor: "transparent" }}
            >
              <Table
                className="table-border width-asign"
                sx={{ borderColor: "grey.500", border: 2 }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow
                    className="table-border"
                    sx={{ "&:last-child td, &:last-child th": { border: 2 } }}
                  >
                    <TableCell
                      style={{ fontWeight: "bold", fontSize: "larger" }}
                      className="table-border"
                    >
                      Date
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold", fontSize: "larger" }}
                      align="left"
                      className="table-border"
                    >
                      Description
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold", fontSize: "larger" }}
                      align="left"
                      className="table-border"
                    >
                      Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  className="table-border"
                  sx={{ "&:last-child td, &:last-child th": { border: 2 } }}
                >
                  {paymentHistory.length > 0 ? (
                    paymentHistory.map((row, index) => (
                      <TableRow
                        className="table-border"
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 2 },
                        }}
                      >
                        <TableCell
                          className="table-border"
                          sx={{ border: 2 }}
                          component="th"
                          scope="row"
                        >
                          {new Date(row?.TransDate)
                            .toISOString()
                            .split("T")[0]
                            .replace(/-/g, "/")}
                        </TableCell>
                        <TableCell className="table-border" align="left">
                          {row?.Description}
                        </TableCell>
                        <TableCell className="table-border" align="left">
                          {row?.Amount}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        align="center"
                        className="noRowData"
                      >
                        No Payment History
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </section>
    </div>
  ),
  accountDetails: () => (
    <div>
      <section className="account-details">
        <div className="account-details-card">
          <h2>Your Account Details</h2>
          <div className="payment-info">
            <p>
              Current Payment Method: <strong>CREDIT CARD</strong>
            </p>
            <p>
              Current Payment Term: <strong>MONTHLY</strong>
            </p>
          </div>
          <div className="update-method">
            <label htmlFor="paymentMethod">New Payment Method</label>
            <select id="paymentMethod" name="paymentMethod">
              <option value="creditCard">Credit Card</option>
              <option value="debitOrder">Debit Order</option>
            </select>
            <button className="updatepayment">UPDATE</button>
          </div>
        </div>
      </section>
      <section className="account-details">
        <div className="account-details-card">
          <h2>Your Account Details</h2>
          <div className="payment-info">
            <p>
              Current Payment Method: <strong>CREDIT CARD</strong>
            </p>
            <p>
              Current Payment Term: <strong>MONTHLY</strong>
            </p>
          </div>
          <div className="update-method">
            <label htmlFor="paymentMethod">New Payment Method</label>
            <select id="paymentMethod" name="paymentMethod">
              <option value="creditCard">Credit Card</option>
              <option value="debitOrder">Debit Order</option>
            </select>
            <button className="updatepayment">UPDATE</button>
            <div>
              <div className="field-cont">
                <label htmlFor="bank">Bank</label>
                <select id="bank" name="bank">
                  <option>Please select</option>
                  <option value="FNB">FNB</option>
                  <option value="ABSA">ABSA</option>
                  <option value="Standard Bank">Standard Bank</option>
                  <option value="Nedbank">Nedbank</option>
                </select>
              </div>
              <div className="field-cont">
                <label htmlFor="accountType">Account Type</label>
                <select id="accountType" name="accountType">
                  <option>Please select</option>
                  <option value="Savings">Savings</option>
                  <option value="Cheque">Cheque</option>
                </select>
              </div>
              <div className="field-cont">
                <label htmlFor="accountHolderName">Account Holder Name</label>
                <input
                  type="text"
                  id="accountHolderName"
                  name="accountHolderName"
                />
              </div>
              <div className="field-cont">
                <label htmlFor="accountNumber">Account Number</label>
                <input type="text" id="accountNumber" name="accountNumber" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  ),
  usageHistory: ({ usageSummary, usageStatement }) => (
    <div className="payment-history">
      <section className="account-details">
        <div className="payment-history-card">
          <h2>Your Usage History</h2>

          <div className="usage-flex-container">
            <div className="usage-flex-container-1">
              <div className="usage-flex-container-collumn">
                {usageSummary.length > 0 ? (
                  usageSummary.map((usage) => (
                    <div className="usage-flex-container-collumn-item">
                      {usage.Name} <br /> Bookings : {usage.Used} Savings :{" "}
                      {usage.Savings} Last Booking : {usage.Last ?? "N/A"}
                    </div>
                  ))
                ) : (
                  <div>No Usage History Data</div>
                )}
              </div>
            </div>
          </div>

          <div className="mobile-swipe-left">
            <h3>
              <PiHandSwipeLeftLight />
            </h3>

            <br />
          </div>

          <div className="payment-history">
            <TableContainer
              component={Paper}
              sx={{ backgroundColor: "transparent" }}
            >
              <Table
                className="table-border width-asign"
                sx={{ borderColor: "grey.500", border: 2 }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow
                    className="table-border"
                    sx={{ "&:last-child td, &:last-child th": { border: 2 } }}
                  >
                    <TableCell
                      style={{ fontWeight: "bold", fontSize: "larger" }}
                      className="table-border"
                    >
                      Date
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold", fontSize: "larger" }}
                      align="left"
                      className="table-border"
                    >
                      Benefit
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold", fontSize: "larger" }}
                      align="left"
                      className="table-border"
                    >
                      Description
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold", fontSize: "larger" }}
                      align="left"
                      className="table-border"
                    >
                      Amount
                    </TableCell>
                    <TableCell
                      style={{ fontWeight: "bold", fontSize: "larger" }}
                      align="left"
                      className="table-border"
                    >
                      Savings
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  className="table-border"
                  sx={{ "&:last-child td, &:last-child th": { border: 2 } }}
                >
                  {usageStatement.length > 0 ? (
                    usageStatement.map((row) => (
                      <TableRow
                        className="table-border"
                        key={row.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 2 },
                        }}
                      >
                        <TableCell className="table-border" align="left">
                          {row.date}
                        </TableCell>
                        <TableCell className="table-border" align="left">
                          {row.benefit}
                        </TableCell>
                        <TableCell className="table-border" align="left">
                          {row.description}
                        </TableCell>
                        <TableCell className="table-border" align="left">
                          {row.amount}
                        </TableCell>
                        <TableCell className="table-border" align="left">
                          {row.savings}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        className="noRowData"
                      >
                        No Usage Statement
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </section>
    </div>
  ),
  howToGuides: () => (
    <div>
      <section className="how-to-guides">
        <div className="how-to-guides-card">
          <h2>How To Guides</h2>

          <Videopop
            videolink="https://www.youtube.com/embed/puieXm1xskc?si=vO24sTBfGIAsNxX_"
            backgroundimg="https://nouf-flp-images.s3.af-south-1.amazonaws.com/resize500.png"
          />
          <br />
          <Videopop
            backgroundimg="https://nouf-flp-images.s3.af-south-1.amazonaws.com/spa500.png"
            videolink="https://www.youtube.com/embed/puieXm1xskc?si=vO24sTBfGIAsNxX_"
          />
          <br />
          <Videopop
            backgroundimg="https://nouf-flp-images.s3.af-south-1.amazonaws.com/car500.png"
            videolink="https://www.youtube.com/embed/puieXm1xskc?si=vO24sTBfGIAsNxX_"
          />
          <br />
          <Videopop
            backgroundimg="https://nouf-flp-images.s3.af-south-1.amazonaws.com/cruise500.png"
            videolink="https://www.youtube.com/embed/puieXm1xskc?si=vO24sTBfGIAsNxX_"
          />
          <br />
          <Videopop
            backgroundimg="https://nouf-flp-images.s3.af-south-1.amazonaws.com/flight500.png"
            videolink="https://www.youtube.com/embed/puieXm1xskc?si=vO24sTBfGIAsNxX_"
          />
          <br />
          <Videopop
            backgroundimg="https://nouf-flp-images.s3.af-south-1.amazonaws.com/coffee500.png"
            videolink="https://www.youtube.com/embed/puieXm1xskc?si=vO24sTBfGIAsNxX_"
          />
          <br />
          <Videopop
            backgroundimg="https://nouf-flp-images.s3.af-south-1.amazonaws.com/movie500.png"
            videolink="https://www.youtube.com/embed/puieXm1xskc?si=vO24sTBfGIAsNxX_"
          />
        </div>
      </section>
    </div>
  ),
  upgradeToday: ({
    userDetails,
    setUserDetails,
    handleUpgradeSubmit,
    idType,
    setIdType,
    idNumber,
    setIdNumber,
    getIdInputLabel,
    countries,
    provinces,
    cities,
  }) => (
    <div>
      <section className="section-bg" id="join-now-form1">
        <div className="join-cont">
          <div className="join-head-cont">
            <h2 style={{ fontSize: "1.8em" }}>Membership Details</h2>
          </div>
          <form onSubmit={handleUpgradeSubmit}>
            <section>
              <div className="form-item mt fi-20">
                <label>Title:</label>
                <select
                  value={
                    userDetails.Title === ""
                      ? userDetails.Family?.[0].Title
                      : userDetails.Title
                  }
                >
                  <option value="">Select Title</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Dr">Dr</option>
                  <option value="Ms">Ms</option>
                </select>
              </div>
              <div className="form-item  mfn fi-40">
                <label>First Name:</label>
                <input
                  type="text"
                  value={
                    userDetails?.FirstName === ""
                      ? userDetails?.Family?.[0]?.FirstName
                      : userDetails?.FirstName
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      FirstName: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="form-item mln fi-40">
                <label>Last Name:</label>
                <input
                  type="text"
                  value={
                    userDetails?.Surname === ""
                      ? userDetails?.Family?.[0]?.LastName
                      : userDetails?.Surname
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      Surname: e.target.value,
                    });
                  }}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>ID Type:</label>
                <select
                  value={idType}
                  onChange={(e) => setIdType(e.target.value)}
                >
                  <option value="RSA ID number">RSA ID number</option>
                  <option value="RSA passport number">
                    RSA passport number
                  </option>
                </select>
              </div>
              <div className="form-item fi-40">
                <label>{getIdInputLabel()}</label>
                <input
                  type="number"
                  value={userDetails?.IDNumber}
                  onChange={(e) => setIdNumber(e.target.value)}
                  minLength={13}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>Email Address:</label>
                <input
                  type="email"
                  value={
                    userDetails?.HomeEmail?.[0]?.EmailAddress === ""
                      ? userDetails?.Family?.[0]?.Email
                      : userDetails?.HomeEmail?.[0]?.EmailAddress
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      HomeEmail: [{ EmailAddress: e.target.value }],
                    });
                  }}
                />
              </div>
              <div className="form-item fi-10">
                <label>Code:</label>
                <select
                  value={phoneCodes[0].code}
                  onChange={(e) => setUserDetails(userDetails)}
                  className="no-spinners"
                >
                  {phoneCodes.map((option) => (
                    <option key={option.code} value={option.code}>
                      {option.code}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-30">
                <label>Cellphone Number:</label>
                <input
                  type="tel"
                  value={
                    userDetails?.CellPhone?.PhoneNumber === ""
                      ? userDetails?.Family?.[0]?.CellPhone
                      : userDetails?.CellPhone?.PhoneNumber
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      CellPhone: { PhoneNumber: e.target.value },
                    });
                  }}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>Confirm Email Address:</label>
                <input
                  type="email"
                  value={userDetails?.HomeEmail?.[0]?.EmailAddress}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                />
              </div>
              <div className="form-item fi-10">
                <label>Code:</label>
                <select
                  value={phoneCodes[0].code}
                  onChange={(e) => setUserDetails(userDetails)}
                  className="no-spinners"
                >
                  {phoneCodes.map((option) => (
                    <option key={option.code} value={option.code}>
                      {option.code}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-30">
                <label>Alternative Cellphone Number:</label>
                <input
                  type="tel"
                  value={
                    userDetails?.CellPhone2?.PhoneNumber === ""
                      ? userDetails?.Family?.[0]?.Telephone
                      : userDetails?.CellPhone2?.PhoneNumber
                  }
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      CellPhone2: { PhoneNumber: e.target.value },
                    });
                  }}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-100">
                <label>Physical Address:</label>
                <input
                  type="text"
                  value={userDetails?.PhysicalAddress?.Line1}
                  onChange={(e) => {
                    setUserDetails({
                      ...userDetails,
                      PhysicalAddress: {
                        ...userDetails.PhysicalAddress,
                        Line1: e.target.value,
                      },
                    });
                  }}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>Country:</label>
                <select
                  value={userDetails?.PhysicalAddress?.CountryID}
                  onChange={(e) =>
                    setUserDetails({
                      ...userDetails,
                      PhysicalAddress: {
                        ...userDetails.PhysicalAddress,
                        CountryID: e.target.value,
                        Country:
                          countries.find(
                            (country) => country.Id === e.target.value
                          )?.name || "South Africa",
                      },
                    })
                  }
                >
                  <option value="">Select Country</option>
                  {countries.map((option) => (
                    <option key={option.Id} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-40">
                <label>Province:</label>
                <select
                  value={userDetails?.PhysicalAddress?.ProvinceID}
                  onChange={(e) =>
                    setUserDetails({
                      ...userDetails,
                      PhysicalAddress: {
                        ...userDetails.PhysicalAddress,
                        ProvinceID: e.target.value,
                        Province:
                          provinces.find(
                            (province) => province.Id === e.target.value
                          )?.name || "Gauteng",
                      },
                    })
                  }
                >
                  <option value="">Select Province</option>
                  {provinces.map((option) => (
                    <option key={option.Id} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>City:</label>
                <select
                  value={userDetails?.PhysicalAddress?.CityID}
                  onChange={(e) =>
                    setUserDetails({
                      ...userDetails,
                      PhysicalAddress: {
                        ...userDetails.PhysicalAddress,
                        CityID: e.target.value,
                        City:
                          cities.find((city) => city.ID === e.target.value)
                            ?.Name || "Johannesburg",
                        PostalCode: cities.find(
                          (city) => city.ID === e.target.value
                        )?.PostalCode,
                      },
                    })
                  }
                >
                  <option value="">Select City</option>
                  {cities.map((option) => (
                    <option key={option.ID} value={option.ID}>
                      {option.Name}
                    </option>
                  ))}
                </select>
              </div>
            </section>
            <div className="btn-cont mobile-btn-cont">
              <button className="btn mobile-btn-join" type="submit">
                PROCEED
              </button>
              <button className="btn mobile-btn-join" type="button">
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  ),
  changePassword: ({ passwordChange, setPasswordChange }) => (
    <div>
      <section className="account-details">
        <div className="account-details-card">
          <h2>Change your password</h2>
          <div className="update-password">
            <div className="field-cont">
              <input
                type="password"
                id="currentPassword"
                placeholder="Current Password"
                name="currentPassword"
                value={passwordChange?.currentPassword}
                onChange={(e) => {
                  setPasswordChange({
                    ...passwordChange,
                    currentPassword: e.target.value,
                  });
                }}
              />
            </div>
            <div className="field-cont">
              <input
                type="password"
                id="newPassword"
                placeholder="New Password"
                name="newPassword"
                value={passwordChange?.newPassword}
                onChange={(e) => {
                  setPasswordChange({
                    ...passwordChange,
                    newPassword: e.target.value,
                  });
                }}
              />
            </div>
            <div className="field-cont">
              <input
                type="password"
                id="confirmPassword"
                placeholder="Confirm Password"
                name="confirmPassword"
                value={passwordChange?.confirmPassword}
                onChange={(e) => {
                  setPasswordChange({
                    ...passwordChange,
                    confirmPassword: e.target.value,
                  });
                }}
              />
            </div>
            <button
              type="button"
              onClick={() => {
                setPasswordChange({
                  ...passwordChange,
                  performPasswordChange: true,
                });
              }}
              disabled={passwordChange?.performPasswordChange}
            >
              {passwordChange?.performPasswordChange
                ? "Please Wait..."
                : "Update"}
            </button>
          </div>
        </div>
      </section>
    </div>
  ),

  logOut: () => <div>Logout</div>,
};

function AccountDetails() {
  const [activeContent, setActiveContent] = useState("profile");
  const [userDetails, setUserDetails] = useState({});
  const [usageSummary, setUsageSummary] = useState([]);
  const [usageStatement, setUsageStatement] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [passwordChange, setPasswordChange] = useState({});
  const [token, setToken] = useState(null);
  const [updateUserDetails, setUpdateUserDetails] = useState(false);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [title, setTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [idType, setIdType] = useState("");
  const [country, setCountry] = useState("");
  const [OPCNumber, setOPCNumber] = useState("");
  const [consultantNumber, setConsultantNumber] = useState("");
  const [managerNumber, setManagerNumber] = useState("");
  const [city, setCity] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [province, setProvince] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [physicalAddress, setPhysicalAddress] = useState("");
  const [office, setOffice] = useState("");
  const [code1, setCode1] = useState("+27");
  const [code2, setCode2] = useState("+27");
  const [cellphoneNumber, setCellphoneNumber] = useState("");
  const [alternativeCellphone, setAlternativeCellphone] = useState("");

  const router = useRouter();

  useEffect(() => {
    // when flp-token && flp-member-id is not available, redirect to login page
    if (
      typeof window !== "undefined" &&
      (!window.localStorage.getItem("flp-token") ||
        !window.localStorage.getItem("flp-member-id"))
    ) {
      router.push("/?p=login");
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setToken(window.localStorage.getItem("flp-access-token"));
    }
  }, []);
  useEffect(() => {
    // Fetch countries only once when component mounts
    countriesRes
      .then((res) => {
        if (res?.Data) {
          setCountries(res.Data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []); // Empty dependency array since this should only run once

  useEffect(() => {
    if (userDetails?.PhysicalAddress?.CountryID) {
      provincesRes(userDetails.PhysicalAddress.CountryID)
        .then((res) => {
          if (res?.Data) {
            setProvinces(res.Data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [userDetails?.PhysicalAddress?.CountryID]); // Only run when CountryID changes

  useEffect(() => {
    if (userDetails?.PhysicalAddress?.ProvinceID) {
      citiesRes(userDetails.PhysicalAddress.ProvinceID)
        .then((res) => {
          if (res?.Data) {
            setCities(res.Data);
            // Only update city details if they're not already set
            if (!userDetails.PhysicalAddress.CityID) {
              setUserDetails((prevDetails) => ({
                ...prevDetails,
                PhysicalAddress: {
                  ...prevDetails.PhysicalAddress,
                  CityID: res.Data[0].ID,
                  City: res.Data[0].Name,
                  PostalCode: res.Data[0].PostalCode,
                },
              }));
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [userDetails?.PhysicalAddress?.ProvinceID]); // Only run when ProvinceID changes

  useEffect(() => {
    if (country) {
      provincesRes(country.Id || country)
        .then((res) => {
          if (res?.Data) {
            setProvinces(res.Data);
            setProvince(res.Data[0]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [country]);

  useEffect(() => {
    if (province) {
      citiesRes(province.Id || province)
        .then((res) => {
          if (res?.Data) {
            setCities(res.Data);
            setCity(res.Data[0]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [province]);

  const allFieldsFilled = () => {
    const isTitleValid = title.trim() !== "";
    const isFirstNameValid = firstName.trim() !== "";
    const isLastNameValid = lastName.trim() !== "";
    // Add checks for other fields if there are more required fields
    // Ensure all other required fields are included in this validation check

    return isTitleValid && isFirstNameValid && isLastNameValid;
  };

  const handleUpgradeSubmit = (e) => {
    e.preventDefault();

    // If not all fields are filled, alert the user
    if (confirmEmail.trim() !== "" && confirmEmail !== email) {
      alert("Emails do not match.");
    } else if (idNumber.trim().length !== 13) {
      alert("ID number should be 13 numerics.");
    } else if (allFieldsFilled()) {
      // If all fields are filled, proceed to Step 2
      setCurrentStep(2);
    } else {
      alert("Please fill in all required fields.");
    }
  };

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.localStorage.getItem("flp-token")
    ) {
      fetchAPI(
        `/ContactDetail?MemberID=${window.localStorage.getItem(
          "flp-member-id"
        )}`,
        "GET",
        null,
        token
      )
        .then((res) => {
          res.MemberID = window.localStorage.getItem("flp-member-id");
          setUserDetails(res);

          // update states
          setTitle(res.Title);
          setFirstName(res.FirstName);
          setLastName(res.Surname);
          setIdType(res.IDType);
          setIdNumber(res.IDNumber);
          setEmail(
            res.HomeEmail[0].EmailAddress
              ? res.HomeEmail[0].EmailAddress
              : res.WorkEmail[0].EmailAddress
          );
          setConfirmEmail(
            res.HomeEmail[0].EmailAddress
              ? res.HomeEmail[0].EmailAddress
              : res.WorkEmail[0].EmailAddress
          );
          setCode1(res.CellPhone[0].Code);
          setCellphoneNumber(res.CellPhone[0].PhoneNumber);
          setCode2(res.CellPhone2[0].Code);
          setAlternativeCellphone(res.CellPhone2[0].PhoneNumber);
          setPhysicalAddress(res.PhysicalAddress.Line1);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [token]);
  useEffect(() => {
    if (userDetails.MemberID && token) {
      // Fetch payment history
      fetchAPI(
        `/AccountsTransactions?MemberID=${userDetails.MemberID}&MemberAccGroupID=19&ACTypeID=1`,
        "GET",
        null,
        token
      )
        .then((res) => {
          setPaymentHistory(res?.OnlineServiceMemberAccountTransactions);
        })
        .catch((err) => {
          console.log(err);
        });

      // Fetch usage summary
      fetchAPI(
        `/UsageSummary?MemberID=${userDetails.MemberID}`,
        "GET",
        null,
        token
      )
        .then((res) => {
          setUsageSummary(res?.Data?.items);
        })
        .catch((err) => {
          console.log(err);
        });

      // Fetch usage statement
      fetchAPI(
        `/UsageStatment?MemberID=${userDetails.MemberID}&page=1`,
        "GET",
        null,
        token
      )
        .then((res) => {
          setUsageStatement(res?.Data?.items);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [userDetails.MemberID, token]); // Only run when MemberID or token changes
  useEffect(() => {
    if (userDetails?.MemberID && token) {
      // Reset bookings before fetching new ones
      setBookings([]);

      // Fetch past holidays
      fetchAPI(
        `/PastHolidays?companyid=55&memberid=${userDetails.MemberID}`,
        "GET",
        null,
        token
      )
        .then((res) => {
          if (res?.status !== 500) {
            setBookings((prevBookings) => [...prevBookings, ...res]);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // Fetch upcoming holidays
      fetchAPI(
        `/UpcomingHolidays?CompanyID=55&MemberID=${userDetails.MemberID}`,
        "GET",
        null,
        token
      )
        .then((res) => {
          if (res?.status !== 500) {
            setBookings((prevBookings) => [...prevBookings, ...res]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [userDetails?.MemberID, token]); // Only run when MemberID or token changes

  useEffect(() => {
    if (!passwordChange?.performPasswordChange) return;

    if (passwordChange?.newPassword === passwordChange?.confirmPassword) {
      fetchAPI(
        "/ChangePassword",
        "POST",
        {
          CompanyID: 55,
          Email: userDetails?.WorkEmail?.[0]?.EmailAddress
            ? userDetails?.WorkEmail?.[0]?.EmailAddress
            : userDetails.HomeEmail?.[0]?.EmailAddress,
          OldPassword: passwordChange.currentPassword,
          NewPassword: passwordChange.newPassword,
        },
        token
      )
        .then((res) => {
          if (res.Success) {
            typeof window !== "undefined" &&
              window.alert("New password was set, please login again.");

            typeof window !== "undefined" &&
              window.localStorage.removeItem("flp-token");
            router.push("/?p=login");
          } else {
            typeof window !== "undefined" &&
              window.alert("Password change failed");
          }

          setPasswordChange({
            ...passwordChange,
            performPasswordChange: false,
          });
        })
        .catch((err) => {
          console.log(err);

          setPasswordChange({
            ...passwordChange,
            performPasswordChange: false,
          });
        });
    } else {
      typeof window !== "undefined" &&
        window.alert("New password and confirm password do not match");
    }
  }, [passwordChange]);

  useEffect(() => {
    if (!updateUserDetails) return;

    fetchAPI(
      "/ContactDetail",
      "POST",
      {
        ...userDetails,
        PhysicalAddress: {
          ...userDetails.PhysicalAddress,
          PostalCode: userDetails?.PhysicalAddress?.PostalCode || "0000",
        },
      },
      token
    )
      .then((res) => {
        if (res?.Success) {
          typeof window !== "undefined" &&
            window.alert("User details updated successfully");

          router.push("/account");
        }
        setUpdateUserDetails(false);
      })
      .catch((err) => {
        console.log(err);
        setUpdateUserDetails(false);
      });
  }, [updateUserDetails]);

  const logout = (e) => {
    e.preventDefault();

    if (typeof window !== "undefined") {
      window.localStorage.removeItem("flp-token");
      window.localStorage.removeItem("flp-member-id");

      router.push("/?p=login");
    }

    router.refresh();
    router.push("/");
  };

  const getIdInputLabel = () => {
    if (idType === "RSA ID number") {
      return "RSA ID Number:";
    } else if (idType === "passport number") {
      return "Passport Number:";
    }
    return "RSA ID Number:";
  };

  return (
    <div className="account-cont">
      <div className="breadcrumb-bar">
        <a href="#">Home</a> &gt; <a href="#">My Account</a> &gt;{" "}
        <span>Profile</span>
        <p>
          Hello!{" "}
          <span>
            {userDetails?.PrintName === ""
              ? `${userDetails?.Family?.[0]?.FirstName} ${userDetails?.Family?.[0]?.LastName}`
              : userDetails?.PrintName}
          </span>
        </p>
      </div>
      <div className="account-container">
        <aside className="sidebar">
          <nav className="menu">
            <p>Menu</p>
            <a
              href="#"
              onClick={() => setActiveContent("profile")}
              className={`menu-item ${
                activeContent === "profile" ? "active" : ""
              }`}
            >
              Profile
            </a>
            <a
              href="#"
              onClick={() => setActiveContent("bookingsHistory")}
              className={`menu-item ${
                activeContent === "bookingsHistory" ? "active" : ""
              }`}
            >
              Bookings History
            </a>
            <a
              href="#"
              onClick={() => setActiveContent("paymentHistory")}
              className={`menu-item ${
                activeContent === "paymentHistory" ? "active" : ""
              }`}
            >
              Payment History
            </a>
            <a
              href="#"
              onClick={() => setActiveContent("accountDetails")}
              className={`menu-item ${
                activeContent === "accountDetails" ? "active" : ""
              }`}
            >
              Account Details
            </a>
            <a
              href="#"
              onClick={() => setActiveContent("usageHistory")}
              className={`menu-item ${
                activeContent === "usageHistory" ? "active" : ""
              }`}
            >
              Usage History
            </a>
            <a
              href="#"
              onClick={() => setActiveContent("howToGuides")}
              className={`menu-item ${
                activeContent === "howToGuides" ? "active" : ""
              }`}
            >
              How to Guides
            </a>
            <a
              href="#"
              onClick={() => setActiveContent("upgradeToday")}
              className={`menu-item ${
                activeContent === "upgradeToday" ? "active" : ""
              }`}
            >
              Upgrade TODAY
            </a>
            <a
              href="#"
              onClick={() => setActiveContent("changePassword")}
              className={`menu-item ${
                activeContent === "changePassword" ? "active" : ""
              }`}
            >
              Change Password
            </a>
            <a
              href="#"
              onClick={logout}
              className={`menu-item ${
                activeContent === "logOut" ? "active" : ""
              }`}
            >
              Log out
            </a>
          </nav>
        </aside>
        <main className="content">
          <MenuContent
            content={activeContent}
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            usageSummary={usageSummary}
            usageStatement={usageStatement}
            paymentHistory={paymentHistory}
            passwordChange={passwordChange}
            setPasswordChange={setPasswordChange}
            updateUserDetails={updateUserDetails}
            setUpdateUserDetails={setUpdateUserDetails}
            countries={countries}
            provinces={provinces}
            cities={cities}
            bookings={bookings}
            handleUpgradeSubmit={handleUpgradeSubmit}
            getIdInputLabel={getIdInputLabel}
            idType={idType}
            setIdType={setIdType}
            idNumber={idNumber}
            setIdNumber={setIdNumber}
          />
        </main>
      </div>
    </div>
  );
}

export default AccountDetails;
